<template>
  <div class="relative">
    <header class="pa-4">
      <v-row>
        <v-col cols="12">
          <v-btn light class="white" @click="addNote">Add Item</v-btn>
        </v-col>
      </v-row>
    </header>

    <article class="service pa-4">
      <row-col
        v-for="item in filteredHeaders"
        :key="item.model"
        :name="`${name}-${item.model}`"
        v-model="cols[item.model]"
        :title="item.title"
        :year="year"
        :color="item.color"
        class="service__col service__col--auto"
        @editNote="editNote"
        @showNote="showNote"
        @removeNote="removeNote"
        @autosave="$emit('autosave')"
      ></row-col>
    </article>

    <!-- Dialog functions -->

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="dialogMode == 'remove'">
        <v-card-title>Are you sure you want to delete this?</v-card-title>

        <v-card-actions>
          <v-btn color="amber" text @click="removeNoteCommit">
            Remove
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <row-add
            :headers="headers"
            @complete="closeDialog"
            @saveNote="saveNote"
          />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <row-show :doc="activeCard" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <row-edit
            :doc="activeCard"
            :headers="headers"
            @complete="closeDialog"
            @editNoteCommit="editNoteCommit"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";

import RowCol from "@/views/user/exercises/timeline/RowCol";
import RowAdd from "@/views/user/exercises/timeline/RowAdd";
import RowEdit from "@/views/user/exercises/timeline/RowEdit";
import RowShow from "@/views/user/exercises/timeline/RowShow";

export default {
  name: "TimelineRowCols",
  props: {
    name: {
      type: String,
      default: "",
    },
    year: {
      type: String,
      default: "2023",
    },
    value: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cols: this.value,
      dialog: false,
      dialogMode: "",
      activeCard: null,
      activeList: null,
    };
  },
  components: {
    RowCol,
    RowAdd,
    RowEdit,
    RowShow,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    filteredHeaders() {
      return this.filters.length > 0
        ? this.headers.filter((x) => this.filters.includes(x.model))
        : this.headers;
    },
  },
  watch: {
    value: {
      handler: function(val) {
        console.log("input cols value chnaged");
        this.cols = val;
      },
      deep: true,
    },
    cols: {
      handler: function(val) {
        console.log("emit cols value changed", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },

  mounted() {},
  methods: {
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    saveNote($event) {
      console.log("save note", $event);
      const item = {
        ...$event,
        index: this.cols[$event.model].length,
        id: new Date().valueOf(),
      };
      this.cols[$event.model].push(item);
      this.closeDialog();
      this.$emit("autosave");
    },
    editNote($event) {
      console.log("edit note", $event);
      this.activeList = $event.model;
      this.activeCard = $event;
      this.dialogMode = "edit";
      this.dialog = true;
    },
    editNoteCommit($event) {
      console.log("save note", $event);
      // we are in the same list
      if (this.activeList === $event.model) {
        console.log("in the same list");
        let items = this.cols[$event.model];
        let item = items.find((x) => x.id === $event.id);
        let indexOfItem = items.indexOf(item);
        this.$set(items, indexOfItem, item);
      } else {
        // remove item from old list
        console.log("changing lists");
        // the old list
        let items = this.cols[this.activeList];
        // the new list
        let newItems = this.cols[$event.model];
        // extract the item
        let item = items.find((x) => x.id === $event.id);
        // set the new index
        item.index = newItems.length;
        let indexOfItem = items.indexOf(item);
        items.splice(indexOfItem, 1);
        // add item to new list
        newItems.push(item);
      }
      this.closeDialog();
      this.$emit("autosave");
    },
    removeNote($event) {
      // console.log("remove note", $event);
      this.activeList = $event.model;
      this.activeCard = $event;
      this.dialogMode = "remove";
      this.dialog = true;
    },
    removeNoteCommit($event) {
      console.log("remove note commit", $event);
      let items = this.cols[this.activeCard.model];
      let item = items.find((x) => x.id === this.activeCard.id);
      let indexOfItem = items.indexOf(item);
      items.splice(indexOfItem, 1);
      this.closeDialog();
      this.$emit("autosave");
    },
    showNote($event) {
      console.log("show note", $event);
      this.activeCard = $event;
      this.dialogMode = "show";
      this.dialog = true;
    },
    closeDialog() {
      this.dialogMode = "";
      this.activeCard = null;
      this.activeList = null;
      this.dialog = false;
    },
  },
};
</script>
